<div class="overlay"></div>
<div class="panel">
  <div class="inside-panel">
    <h2>{{ labelService.getLabel(panelTitle) }}</h2>

    <form [formGroup]="eventForm" class="event-form">
      <mat-form-field appearance="fill" color="primary">
        <mat-label>{{ labelService.getLabel("title") }}</mat-label>
        <input matInput formControlName="title" type="text" />
      </mat-form-field>

      <mat-slide-toggle
        [formControlName]="'isMonthOnly'"
        class="date-mode-toggle"
      >
        {{ labelService.getLabel("seleziona solo mese e anno") }}
      </mat-slide-toggle>

      <mat-form-field appearance="fill" color="primary">
        <mat-label>{{ labelService.getLabel("start_date") }}</mat-label>
        <input
          matInput
          [matDatepicker]="startPicker"
          formControlName="startDate"
          [placeholder]="
            eventForm.get('isMonthOnly')?.value ? 'MM/YYYY' : 'DD/MM/YYYY'
          "
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="startPicker"
        ></mat-datepicker-toggle>
        <mat-datepicker
          #startPicker
          [startView]="
            eventForm.get('isMonthOnly')?.value ? 'multi-year' : 'month'
          "
          (monthSelected)="
            handleMonthYearSelection($event, 'startDate', startPicker)
          "
        ></mat-datepicker>
      </mat-form-field>

      @if (!panelTitle.includes("Sotto Evento")) {
        <mat-form-field appearance="fill" color="primary">
          <mat-label>{{ labelService.getLabel("end_date") }}</mat-label>
          <input
            matInput
            [matDatepicker]="endPicker"
            formControlName="endDate"
            [placeholder]="
              eventForm.get('isMonthOnly')?.value ? 'MM/YYYY' : 'DD/MM/YYYY'
            "
          />
          <mat-datepicker-toggle
            matSuffix
            [for]="endPicker"
          ></mat-datepicker-toggle>
          <mat-datepicker
            #endPicker
            [startView]="
              eventForm.get('isMonthOnly')?.value ? 'multi-year' : 'month'
            "
            (monthSelected)="
              handleMonthYearSelection($event, 'endDate', endPicker)
            "
          ></mat-datepicker>
        </mat-form-field>
      }
    </form>

    <div class="panel-buttons">
      <button mat-stroked-button class="button-white" (click)="onCancel()">
        {{ labelService.getLabel("cancel") }}
      </button>
      <button
        mat-raised-button
        class="button-white"
        (click)="onConfirm()"
        [disabled]="
          eventForm.get('title')?.value === '' ||
          eventForm.get('startDate')?.value === '' ||
          isBtnClicked
        "
      >
        {{ labelService.getLabel("confirm") }}
      </button>
    </div>
  </div>
</div>
